module.exports = __webpack_public_path__ + "img/upload-file-icon.3822ea00.svg";